import { ref } from 'vue';

const getAbsenceTypes = () => {
    const absencetypes_error = ref(null);
    const absencetypes = ref(null);

    const loadAbsenceTypes = async () => {
      try {
        let data = await fetch("/api/absencetypes");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        absencetypes.value = await data.json();

        // console.log('absencetypes', absencetypes.value);
      } catch (err) {
        absencetypes_error.value = err.message;
      }
    };

    return { absencetypes, absencetypes_error, loadAbsenceTypes};
}

export default getAbsenceTypes;